/**
 * UUID v4 para event_id (deduplicação futura entre pixel do navegador e envio server-side).
 * crypto.randomUUID só existe em contexto seguro (https); fallback com getRandomValues.
 */
export default function uuid() {
    try {
        if (window.crypto && typeof window.crypto.randomUUID === "function") {
            return window.crypto.randomUUID();
        }
    } catch (e) {
        // segue para o fallback
    }

    const bytes = new Uint8Array(16);
    try {
        window.crypto.getRandomValues(bytes);
    } catch (e) {
        for (let i = 0; i < bytes.length; i++) {
            bytes[i] = Math.floor(Math.random() * 256);
        }
    }

    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");

    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
